<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                      <!--<vs-button  @click="edit()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-edit" icon-pack="feather" type="filled"></vs-button>
                      <vs-button  @click="requestPassword('doDelete')" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-trash" icon-pack="feather" type="filled"></vs-button>-->
                      <h4>{{$t('Labels.Detail')}}</h4>
                      <table cellspancing="5" class="border-separate mt-5">
                        <tbody>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Name')}}</td>
                            <td class=" px-2 py-1">{{response.name}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Profile')}}</td>
                            <td class=" px-2 py-1">{{response.device_profile_uuid}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$tc('Labels.App',1)}}</td>
                            <td class=" px-2 py-1">{{response.app_id}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Port')}}</td>
                            <td class=" px-2 py-1">{{response.port}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Type')}}</td>
                            <td class=" px-2 py-1">{{response.type}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.CreatedAt')}}</td>
                            <td class=" px-2 py-1">{{response.created_at}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
                            <td class=" px-2 py-1">{{response.user_creator  != null ? response.user_creator.first_name + ' ' + response.user_creator.last_name:''}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.UpdatedAt')}}</td>
                            <td class=" px-2 py-1">{{response.updated_at}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Modifier')}}</td>
                            <td class=" px-2 py-1">{{response.user_update != null ? response.user_update.first_name + ' ' + response.user_update.last_name:''}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </vx-card>
                </div>
                
            </div>
            <div class="w-full">
              <vx-card class="grid-view-item mb-base overflow-hidden">
                  <h4>{{$t('Labels.Assignments')}}</h4>
                <table cellspancing="5" class="border-separate mt-5" v-if="response">
                  <tbody>
                    <tr>
                      <td class="bg-grey-light px-4 py-1 rounded ">{{$tc('Labels.Device',2)}}</td>
                      <td class=" px-2 py-1">{{response.count_devices}}</td>
                      <vs-button @click="goDevices()" type="border">{{$t("Labels.GoTo") + ' ' + $tc("Labels.Device",2)}}</vs-button>
                    </tr>
                  </tbody>
                </table>
              </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import valueItem from '@/components/valueItem/valueItem.vue'
import listItem from '@/components/listItem/listItem.vue'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    valueItem,
    listItem
  },

  data () {
    return {
      response: [],
      uuid: this.$route.params.uuid,
      logLimit: 5,
      logData: [],
      callDoDelete: false,
      callActivate: false
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `device_types/${this.uuid}`,
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.response = response.data.data

      })
    },
    goDevices () {
      window.location.href =  `/devices?device_type_uuid=${this.uuid}`
    },
    edit (uuid) {
      window.location.href =  `/devices/${this.uuid}/update`
    },
    requestPassword (action) {
      if (action == 'doDelete') {
        this.callDoDelete = true
        this.callActivate = false
      } else {
        this.callDoDelete = false
        this.callActivate = true
      }
      globalPassActions.show()
    },
    async doDelete () {
      const params = {
        url: `devices/${this.response.deveui}`,
        method: 'DELETE',
        params: {}
      }
      await request(params).then(response => {
      }) 
    }
  },
  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.DeviceTypes')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Detail')
    this.$route.meta.pageTitle = this.$t('Path.Detail')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getResponse()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) if (this.callDoDelete) this.doDelete()
      else this.activate()
    }
  }
}
</script>
